// extracted by mini-css-extract-plugin
export var audioPlayer = "_kv-0";